export enum BusinessMaternityCoverageDuration {
  ONE_HUNDRED_TWELVE_DAYS = 'ONE_HUNDRED_TWELVE_DAYS',
  ONE_HUNDRED_TWENTY_SIX_DAYS = 'ONE_HUNDRED_TWENTY_SIX_DAYS',
  ONE_HUNDRED_FIFTY_DAYS = 'ONE_HUNDRED_FIFTY_DAYS',
}

export const BUSINESS_MATERNITY_COVERAGE_DURATION_VALUES = Object.values(
  BusinessMaternityCoverageDuration
);

export const getBusinessMaternityCoverageDurationLabel = (
  value: BusinessMaternityCoverageDuration
) => {
  switch (value) {
    case BusinessMaternityCoverageDuration.ONE_HUNDRED_TWELVE_DAYS:
      return $localize`112 jours`;
    case BusinessMaternityCoverageDuration.ONE_HUNDRED_TWENTY_SIX_DAYS:
      return $localize`126 jours`;
    case BusinessMaternityCoverageDuration.ONE_HUNDRED_FIFTY_DAYS:
      return $localize`150 jours`;
  }
};
